<template>
  <div class="contract-agreement">
    <div class="contract-agreement-title">补充协议（{{ total }}）</div>
    <div class="contract-agreement-list">
      <div
        class="contract-agreement-item"
        v-for="(item, index) in data"
        :key="index"
        @click="handContractAgreenInfo(item)"
      >
        {{ item.pactName }}
      </div>
    </div>
    <div class="contract-agreement-btn" @click="handMore" v-if="total > 3">
      查看更多
    </div>
    <!-- <div class="contract-agreement-btn" v-else>没有更多了</div> -->
  </div>
</template>

<script>
import { getUrlParams } from 'common/js/mUtils';
export default {
  methods: {
    handMore() {
      this.$emit('handMore');
    },
    handContractAgreenInfo(data) {
      let { contractguid } = data;
      let { mainContract, mainContractGuid } = this;
      let { employeeName, mobile } = getUrlParams();
      this.$router.push({
        name: 'cooperationAgreementDetail',
        query: {
          contractguid,
          mainContract,
          employeeName: decodeURIComponent(employeeName),
          mobile,
          mainContractGuid
        }
      });
    }
  },
  props: {
    total: {
      type: Number,
      default: 10
    },
    data: {
      type: Array,
      default: () => []
    },
    mainContract: {
      type: String,
      default: ''
    },
    mainContractGuid: {
      type: String,
      default: ''
    }
  },
  created() {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.contract-agreement {
  padding-left: 32px;
  padding-right: 32px;
  background: transparent;
  position: relative;
  z-index: 9;
  .contract-agreement-title {
    height: 80px;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 80px;
    position: relative;
  }
  .contract-agreement-title::after {
    position: absolute;
    content: '';
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    transform: scaleY(0.5);
    background: #efefef;
  }
  .contract-agreement-list {
    .contract-agreement-item {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 1.5;
      padding: 24px 0px;
      position: relative;
    }
    .contract-agreement-item::after {
      position: absolute;
      content: '';
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 1px;
      transform: scaleY(0.5);
      background: #efefef;
    }
  }
  .contract-agreement-btn {
    height: 88px;
    line-height: 88px;
    text-align: center;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(54, 196, 144, 1);
  }
}
.contract-agreement::after {
  position: absolute;
  content: '';
  top: 0px;
  left: 0px;
  width: 100%;
  height: 1px;
  transform: scaleY(0.5);
  background: #efefef;
}
</style>
